import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="home-page">
      {/* Hero Section - Full Screen Brand Showcase */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="hero-glow hero-glow-1"></div>
          <div className="hero-glow hero-glow-2"></div>
        </div>
        <div className="hero-container">
          {/* Generate 66 sparkle stars across entire hero section */}
          {Array.from({ length: 66 }).map((_, index) => (
            <span key={index} className="hero-sparkle" data-index={index}></span>
          ))}
          <div className="hero-logo-wrapper">
            <div className="hero-logo-frame">
              <img 
                src="/assets/snorelab_icon.png" 
                alt="SynorLab icon" 
                className="hero-logo"
              />
            </div>
          </div>
          <div className="hero-content">
            <h1 className="hero-title">{t('home.title')}</h1>
            <p className="hero-subtitle">{t('home.subtitle')}</p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-card">
            <h2 className="mission-title">{t('home.mission')}</h2>
            <p className="mission-description">{t('home.description')}</p>
            <p className="mission-expectation">{t('home.expectation')}</p>
          </div>
        </div>
      </section>

      {/* Values Section - Horizontal Flow */}
      <section className="values-section">
        <div className="container">
          <div className="values-flow">
            <div className="value-item">
              <div className="value-number">01</div>
              <h3 className="value-title">{t('home.feature1Title')}</h3>
              <p className="value-description">{t('home.feature1Description')}</p>
            </div>
            <div className="value-divider"></div>
            <div className="value-item">
              <div className="value-number">02</div>
              <h3 className="value-title">{t('home.feature2Title')}</h3>
              <p className="value-description">{t('home.feature2Description')}</p>
            </div>
            <div className="value-divider"></div>
            <div className="value-item">
              <div className="value-number">03</div>
              <h3 className="value-title">{t('home.feature3Title')}</h3>
              <p className="value-description">{t('home.feature3Description')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <Link to="/products" className="cta-button">
            {t('home.cta')}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;

